import React, { FC, memo } from 'react';
import { Container, Message, Name, StopButton } from './styles';
import { Props } from './types';

const ImpersonationBanner: FC<Props> = ({ userName, onStop }) => (
  <Container role="alert">
    <Message>
      You are impersonating{userName ? ' ' : ''}
      {userName && <Name>{userName}</Name>}.
    </Message>
    <StopButton type="button" onClick={onStop}>
      Stop impersonating
    </StopButton>
  </Container>
);

export default memo(ImpersonationBanner);
